import React, { useEffect } from "react";
import Navbar from "./Navbar";
import HiresText from "./commonTextPages/HiresText";
import useResponsiveFlags from "../hooks/useResponsiveFlags";

export default function Hires() {
  const { isDesktop } = useResponsiveFlags();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Navbar />
      <div
        style={{
          marginLeft: isDesktop ? "300px" : "0",
          paddingTop: isDesktop ? "" : "101px",
        }}
      >
        <HiresText loggedin={true} />
      </div>
    </>
  );
}
